import { api } from "./api";

export const classList = async (params: {
  startDate?: Date;
  endDate?: Date;
}): Promise<any> => {
  const { data } = await api.get("class", { params });
  return data;
};

export const classById = async (id: string): Promise<any> => {
  const { data } = await api.get("class/" + id);
  return data;
};

export const classOptions = async (): Promise<any> => {
  const { data } = await api.get("class/options/list");
  return data;
};

export const classCadaster = async (body: {
  startTime: Date;
  endTime: Date;
  dayWeek: string;
  name: string;
  description?: string;
  fightsId?: string;
  spacesId?: string;
  professorId?: string[];
  automaticCompletion?: boolean;
  limit?: string;
  checkinLock?: boolean;
}): Promise<any> => {
  const { data } = await api.post("class/cadaster", body);
  return data;
};

export const classUpdate = async (body: {
  id: string;
  startTime: Date;
  endTime: Date;
  dayWeek: string;
  name: string;
  description?: string;
  fightsId?: string;
  spacesId?: string;
  professorId?: string[];
  students?: string[];
  automaticCompletion?: boolean;
  limit?: string;
  checkinLock?: boolean;
}): Promise<any> => {
  const { data } = await api.put("class/update", body);
  return data;
};

export const classDelete = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("class/delete", body);
  return data;
};
